import React, { Component } from 'react';
import { EditorState } from 'draft-js';
import { Button } from '../../../../../../../../../ui-kit';

import CommentTextEditor, { getContentState } from '../../../../CommentTextEditor';
import { getCurrentUserId } from '../../../../../../../../../common/utils';

import '../styles/_add-reply.scss';



















class AddReply extends Component {
  static defaultProps = {
    visible: true
  };

  constructor(props) {
    super(props);

    this.state = {
      busy: false
    };
  }

  handleAddReply = async (e) => {
    e.stopPropagation();

    const {
      createReply,
      replyRef,
      clearInput,
      comment,
      comment: { commentId },
      editorState,
      shotId,
      sceneId
    } = this.props;

    const { json, plainText } = getContentState(editorState);

    if (!plainText.trim()) {return;}

    this.setState({ busy: true });

    await createReply(
      {
        input: {
          content: json,
          parentId: commentId,
          shotId,
          sceneId
        },
        parentComment: comment
      }
    );

    this.setState({ busy: false });

    clearInput();

    if (replyRef) {
      replyRef.scrollTo({ top: replyRef.scrollHeight, behavior: 'smooth' });
    }
  };

  render() {
    const {
      comment: { isResolved },
      visible,
      onUpdateContent,
      editorState,
      resourceOrganisationId,
      onInputFocus
    } = this.props;

    const { busy } = this.state;

    const { plainText } = getContentState(editorState);

    const hasCurrentUserId = !!getCurrentUserId();

    return visible ?
    <div className="add-reply">
        <CommentTextEditor
        placeholder="Enter reply"
        editorState={editorState}
        onUpdateContent={onUpdateContent}
        onSave={this.handleAddReply}
        disabled={isResolved}
        organisationId={resourceOrganisationId}
        onFocus={onInputFocus}
        setFocusOnMount={hasCurrentUserId} />

        <div className="add-reply__footer">
          <Button
          onClick={(e) => this.handleAddReply(e)}
          type="SECONDARY"
          busy={busy}
          disabled={!plainText.trim() || isResolved}>

            Submit
          </Button>
        </div>
      </div> :
    null;
  }
}

export default AddReply;